module.exports = __webpack_public_path__ + "img/home1.516228a6.png";